<google-map id="map"
            [mapId]="GOOGLE_MAP_ID"
            [center]="center"
            [zoom]="zoom"
            [options]="{
              mapTypeControl: false
            }"
            height="100%"
            width="100%"
            (mapClick)="onMapClick()"
            (mapDrag)="onMapClick()"
>

  @for (marker of markers; track marker.place._id!) {
    <map-advanced-marker
      #markerElem="mapAdvancedMarker"
      [title]="marker.place.name"
      [position]="{lat: marker.latitude, lng: marker.longitude}"
      [content]="marker.content"
      [options]="{gmpClickable: true}"
      (mapClick)="onMarkerClick(markerElem, marker.place)">
    </map-advanced-marker>

    <map-info-window #mapInfoWindow [options]="{headerDisabled: true, maxWidth: 240}">
      <app-place-box *ngIf="place"
                     [place]="place!"
                     [showLikeButton]="false"/>
    </map-info-window>
  }

</google-map>
